import type { MargauxScheduleItem } from "@/lib/facilitator/queries";
import styles from "./margaux-schedule-panel.module.scss";

export interface MargauxSchedulePanelProps {
  items: MargauxScheduleItem[];
  isLoading?: boolean;
  isError?: boolean;
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

function formatScheduledFor(iso: string): string {
  const d = new Date(iso);
  const day = WEEKDAYS[d.getUTCDay()];
  const hour = d.getUTCHours();
  const minute = d.getUTCMinutes().toString().padStart(2, "0");
  return `${day} ${hour}:${minute} UTC`;
}

export function MargauxSchedulePanel({
  items,
  isLoading,
  isError,
}: MargauxSchedulePanelProps) {
  return (
    <section
      className={styles.card}
      aria-labelledby="margaux-schedule-heading"
      data-testid="margaux-schedule-panel"
    >
      <header className={styles.cardHead}>
        <h2 id="margaux-schedule-heading" className={styles.cardTitle}>
          Margaux's upcoming posts
        </h2>
        <span className={styles.cardSubtitle}>read-only</span>
      </header>
      {isLoading ? (
        <div className={styles.empty}>Loading…</div>
      ) : isError ? (
        <div className={styles.empty}>Couldn't load Margaux's schedule.</div>
      ) : items.length === 0 ? (
        <div className={styles.empty}>
          No more scheduled posts before this room ends.
        </div>
      ) : (
        <ul className={styles.list}>
          {items.map((item) => (
            <li key={item.jobName} className={styles.row}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.when}>
                {formatScheduledFor(item.scheduledFor)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
